import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

export const isSupabaseConfigured = !!(supabaseUrl && supabaseAnonKey);

// Passa esplicitamente il WebSocket nativo del browser al client realtime.
// Questo bypassa la detection automatica di realtime-js che può essere
// alterata dal bundling Vite/Rollup in produzione.
const WS = typeof globalThis !== "undefined" && globalThis.WebSocket
  ? globalThis.WebSocket
  : (typeof WebSocket !== "undefined" ? WebSocket : undefined);

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      realtime: WS ? { transport: WS } : undefined,
    })
  : null;

export default supabase;
